export const CARD_TYPE_LABELS: Record<string, string> = {
  digital: 'Digital',
  titular: 'Titular',
  adicional: 'Adicional',
};

export const PROGRESS_COLORS = {
  success: {
    bar: 'bg-green-500',
    bg: 'bg-green-100',
  },
  warning: {
    bar: 'bg-yellow-500',
    bg: 'bg-yellow-100',
  },
  danger: {
    bar: 'bg-red-500',
    bg: 'bg-red-100',
  },
} as const;

export function getProgressVariant(
  percentUsed: number
): 'success' | 'warning' | 'danger' {
  if (percentUsed >= 100) return 'danger';
  if (percentUsed >= 80) return 'warning';
  return 'success';
}

export const TOAST_DEFAULT_TIMEOUT_MS = 5000;
